import { defineMessages } from 'react-intl'

const messages = defineMessages({
  title: {
    id: 'HomeContent.title',
    description: 'Texto para el titulo de la página',
    defaultMessage: 'La herramienta de diagnóstico regional europeo de Orkestra'
  },
  updated: {
    id: 'HomeContent.updated',
    description: 'Texto para el small al lado del titulo',
    defaultMessage: 'actualizado a {lastUpdated}'
  },
  welcome: {
    id: 'HomeContent.welcome',
    description: 'Parrafo de bienvenida a la pagina',
    defaultMessage:
			'Bienvenido a la herramienta de <strong>diagnóstico regional</strong> de Orkestra. Aquí podrás estudiar de forma <strong>comparada</strong> la situación y evolución de los <strong>indicadores</strong> clave para la competitividad a partir de los datos más recientes a nivel <strong>regional</strong> europeo.'
  },
  secondParagraph: {
    id: 'HomeContent.secondParagraph',
    description: 'Segundo párrafo introductorio',
    defaultMessage:
			'Esta herramienta persigue propiciar la mejora del estudio de la competitividad regional ofreciendo un punto de partida para diferentes análisis regionales realizados tanto dentro como fuera del Instituto.'
  },
  videoButton: {
    id: 'HomeContent.videoButton',
    description: 'Texto para el boton del video',
    defaultMessage: 'Ver vídeo explicativo'
  },
  benchmarking: {
    id: 'HomeContent.benchmarking',
    description: 'Benchmarking',
    defaultMessage: 'Benchmarking'
  },
  benchmarkingParagraph: {
    id: 'HomeContent.benchmarkingParagraph',
    description: 'Parrafo sobre el benchmarking',
    defaultMessage:
			'Al realizar comparaciones es importante no mezclar peras con manzanas y es por ello que Orkestra ha desarrollado una <a href="{benchmarkingLink}">metodología de benchmarking</a> que identifica, para cada región europea, las regiones con <b>estructuras similares</b>. Así podrá compararse con sus "iguales".'
  },
  lastData: {
    id: 'HomeContent.lastData',
    description: 'Ultimos datos',
    defaultMessage: 'Últimos datos'
  },
  lastDataParagraph: {
    id: 'HomeContent.lastDataParagraph',
    description: 'Parrafo sobre los ultimos datos',
    defaultMessage:
			'El observatorio se mantiene siempre <b>actualizado</b> con los últimos datos disponibles para el conjunto de regiones europeas. Para ello utilizamos una plataforma de datos innovadora que nos permite automatizar el proceso de recolección y procesado de datos.'
  },
  competitivenessFrame: {
    id: 'HomeContent.competitivenessFrame',
    description: 'Marco de competitividad',
    defaultMessage: 'Marco de competitividad'
  },
  competitivenessFrameParagraph: {
    id: 'HomeContent.competitivenessFrameParagraph',
    description: 'Parrafo sobre el marco de competitividad',
    defaultMessage:
			'En Orkestra entendemos la competitividad como un <strong>medio para el bienestar</strong> de la sociedad y esto queda reflejado en el <a href="{methodologyLink}">marco analítico</a> desarrollado por el instituto. Este marco define diferentes niveles de indicadores en función de su papel: resultado, desempeño intermedio, determinantes y fundamentos.'
  },
  reportPanelTitle: {
    id: 'HomeContent.reportPanelTitle',
    description: 'Panel de diagnóstico',
    defaultMessage: 'NUEVO Panel del Informe de Competitividad del País Vasco'
  },
  reportPanelParagraph: {
    id: 'HomeContent.reportPanelParagraph',
    description: 'Parrafo sobre panel de diagnóstico',
    defaultMessage:
			'Acompañando el diagnóstico incluído en el <a href="https://www.orkestra.deusto.es/es/investigacion/informe-de-competitividad-del-pais-vasco">Informe de Competitividad del País Vasco</a>, este <a href="{reportPanelLink}">nuevo panel</a> recoge el nivel y evolución de nuevos indicadores inscritos en el <a href="{methodologyLink}">marco de competitividad de Orkestra</a>, así como su comparación con la UE-27.'  },
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/HomeContent/messages.js